import { render, staticRenderFns } from "./UserHeaders.vue?vue&type=template&id=6555f738&scoped=true"
import script from "./UserHeaders.vue?vue&type=script&lang=js"
export * from "./UserHeaders.vue?vue&type=script&lang=js"
import style0 from "./UserHeaders.vue?vue&type=style&index=0&id=6555f738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6555f738",
  null
  
)

export default component.exports